// Generated on 2026-01-05T16:52:29.990Z
// This file contains preloaded products top brands data from the API
// Do not edit manually - use 'npm run generate:products-top-brands-data' to regenerate

export const preloadedProductsTopBrands: any = [
  {
    "marca": "DORMAN",
    "cantidadProductosVendidos": "33374"
  },
  {
    "marca": "NAKAMOTO",
    "cantidadProductosVendidos": "22438"
  },
  {
    "marca": "GSP NORTH AMERICA",
    "cantidadProductosVendidos": "21553"
  },
  {
    "marca": "WAGNER QUICKSTOP",
    "cantidadProductosVendidos": "19620"
  },
  {
    "marca": "FEBEST",
    "cantidadProductosVendidos": "16553"
  },
  {
    "marca": "ONNURI",
    "cantidadProductosVendidos": "15798"
  },
  {
    "marca": "VALVOLINE",
    "cantidadProductosVendidos": "14786"
  },
  {
    "marca": "BANDO",
    "cantidadProductosVendidos": "14673"
  },
  {
    "marca": "DENSO",
    "cantidadProductosVendidos": "13562"
  },
  {
    "marca": "DNJ",
    "cantidadProductosVendidos": "12443"
  },
  {
    "marca": "MAHLE ORIGINAL",
    "cantidadProductosVendidos": "11902"
  },
  {
    "marca": "BECK/ARNLEY",
    "cantidadProductosVendidos": "10431"
  },
  {
    "marca": "ECOGARD",
    "cantidadProductosVendidos": "9067"
  },
  {
    "marca": "FAG",
    "cantidadProductosVendidos": "8172"
  },
  {
    "marca": "BLUE PRINT",
    "cantidadProductosVendidos": "7926"
  },
  {
    "marca": "555",
    "cantidadProductosVendidos": "7877"
  },
  {
    "marca": "DAYCO",
    "cantidadProductosVendidos": "7289"
  },
  {
    "marca": "PT",
    "cantidadProductosVendidos": "7157"
  },
  {
    "marca": "MOOG",
    "cantidadProductosVendidos": "6620"
  },
  {
    "marca": "PRESTONE",
    "cantidadProductosVendidos": "6611"
  },
  {
    "marca": "MOTORAD",
    "cantidadProductosVendidos": "6438"
  },
  {
    "marca": "MOOG EU",
    "cantidadProductosVendidos": "6197"
  },
  {
    "marca": "DORMAN PREMIUM",
    "cantidadProductosVendidos": "6182"
  },
  {
    "marca": "TENACITY",
    "cantidadProductosVendidos": "6015"
  },
  {
    "marca": "HS",
    "cantidadProductosVendidos": "5724"
  },
  {
    "marca": "STANDARD/INTERMOTOR",
    "cantidadProductosVendidos": "5665"
  },
  {
    "marca": "WALKER",
    "cantidadProductosVendidos": "5308"
  },
  {
    "marca": "NATIONAL",
    "cantidadProductosVendidos": "5222"
  },
  {
    "marca": "WAGNER",
    "cantidadProductosVendidos": "4966"
  },
  {
    "marca": "EAGLE BHP",
    "cantidadProductosVendidos": "4642"
  }
];

export default preloadedProductsTopBrands;
